export default {
      id: "caret-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#caret",
      toString: function () {
        return this.url;
      }
    }